// Short for actions to launch popups from links (eg. menu)
a.ac = function(inp){
	var parts = inp.split('/').filter(function(e){return e != ''});
	if (parts.length > 0) {
		if (parts[0] == 'reservation') {
			if (parts[1] == 'new') {
				
			}
		}
	}
}